const fractionDigitsCache = new Map();

const currencyFractionDigits = (currency = "EUR") => {
  const code = String(currency || "EUR").trim().toUpperCase();
  if (fractionDigitsCache.has(code)) return fractionDigitsCache.get(code);

  let digits = 2;
  try {
    digits = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: code,
    }).resolvedOptions().maximumFractionDigits;
  } catch {
    digits = 2;
  }

  fractionDigitsCache.set(code, digits);
  return digits;
};

const roundMoney = (value, currency = "EUR") => {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return 0;
  const scale = 10 ** currencyFractionDigits(currency);
  const rounded = Math.round((Math.abs(numeric) + Number.EPSILON) * scale) / scale;
  return Object.is(numeric, -0) || numeric < 0 ? -rounded : rounded;
};

const sumMoney = (values, currency = "EUR") => (values || []).reduce(
  (total, value) => roundMoney(total + roundMoney(value, currency), currency),
  0,
);

export {
  currencyFractionDigits,
  roundMoney,
  sumMoney,
};
